// extracted by mini-css-extract-plugin
export default {"root":"ID91c44ok7","root_selected":"oTCjE9oMh5","thumbnail":"kIGRMnuWDj","title":"SLfvba5uD0","description":"_9XxVlo2nN"};